export { isCustomPage, isHomePage } from './custom-pages';
